import { Star, Quote, BadgeCheck, MessageCircle } from 'lucide-react';

const TestimonialsSection = () => {
  // Avis réels Google — Allô Réparations (4,7/5 · 579 avis)
  // Source : https://maps.app.goo.gl/X6hhYa4BE7uPptRVA
  const testimonials = [
    {
      name: 'M. Rico',
      rating: 5,
      date: 'Il y a 2 mois',
      text: "Super expérience ! Je suis venue pour faire réparer mon téléphone dont l'écran était complètement noir, et franchement rien à redire. Le monsieur est super sympa, très professionnel.",
      device: 'Réparation écran',
      verified: true,
      avatar: 'M',
      color: 'from-pink-400 to-rose-500',
    },
    {
      name: 'Alexandre Launes',
      rating: 5,
      date: 'Il y a 5 mois',
      text: "Magasin incroyable, sympathique et surtout très honnête. Je pensais que c'était mon écran qui était HS alors que c'était juste la fiche de connexion, et ils n'ont pas hésité à me le dire. Le prix est plus bas que dans les autres magasins.",
      device: 'Diagnostic gratuit',
      verified: true,
      avatar: 'A',
      color: 'from-blue-400 to-indigo-500',
    },
    {
      name: 'Christophe Farque',
      rating: 5,
      date: 'Il y a 2 mois',
      text: "Sourire, gentillesse, professionnalisme, rapidité, explications claires et concises et petits prix, tout est là pour la meilleure solution pour mon téléphone. Encore merci à l'équipe !",
      device: 'Réparation téléphone',
      verified: true,
      avatar: 'C',
      color: 'from-purple-400 to-violet-500',
    },
    {
      name: 'LIYIN WU',
      rating: 5,
      date: 'Il y a 4 mois',
      text: "Atelier de dépannage téléphonique et informatique vraiment professionnel, avec un tarif concurrentiel et un accueil super sympathique. Chaque fois que j'ai des soucis avec mon mobile ou PC portable, je leur ai toujours ramené et ils m'ont toujours bien dépannée. Je recommande sans hésitation.",
      device: 'Mobile + PC',
      verified: true,
      avatar: 'L',
      color: 'from-cyan-400 to-teal-500',
    },
    {
      name: 'victor martin',
      rating: 5,
      date: 'Il y a 3 mois',
      text: "Très gentil et honnête, je suis venu à la boutique pour réparer le tactile de mon téléphone et il a été réparé gratuitement. C'était une manip de 10 secondes pour refaire fonctionner le tactile mais je ne le savais pas, il aurait pu me faire payer.",
      device: 'Réparation tactile',
      verified: true,
      avatar: 'V',
      color: 'from-amber-400 to-orange-500',
    },
    {
      name: 'Corentin K.',
      rating: 5,
      date: 'Il y a 2 mois',
      text: "Étant moi-même réparateur, j'aperçois un réel professionnalisme chez Dylan, Jérôme et Louane. Boutique sérieuse, équipe compétente, je recommande à 100%.",
      device: 'Avis pro · Local Guide',
      verified: true,
      avatar: 'C',
      color: 'from-green-400 to-emerald-500',
    },
  ];

  const averageRating = "4,7";
  const reviewCount = "579";
  const googleMapsUrl = "https://maps.app.goo.gl/X6hhYa4BE7uPptRVA";

  return (
    <section
      id="avis"
      className="section-spacing relative overflow-hidden"
      data-testid="testimonials-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-white via-slate-50/50 to-white" />
      
      {/* Decorative blobs — fournissent la couleur derrière le verre */}
      <div className="absolute top-[40%] left-[5%] w-72 h-72 bg-gradient-to-br from-amber-300/30 to-orange-300/25 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-[55%] left-[35%] w-80 h-80 bg-gradient-to-br from-blue-300/25 to-cyan-300/20 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute top-[45%] right-[8%] w-72 h-72 bg-gradient-to-br from-purple-300/25 to-pink-300/20 rounded-full blur-3xl pointer-events-none" />

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-yellow-100 to-amber-100 rounded-full mb-6">
            <MessageCircle size={16} className="text-amber-500" />
            <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider" data-testid="testimonials-label">
              Avis clients
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-6" data-testid="testimonials-title">
            Ce que disent{' '}
            <span className="gradient-text">nos clients</span>
          </h2>
          
          {/* Average Rating Card */}
          <div className="inline-flex items-center gap-6 bg-white rounded-2xl px-8 py-5 shadow-xl shadow-slate-200/50 border border-slate-100 mt-4" data-testid="average-rating">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  size={32}
                  className="text-yellow-400 fill-yellow-400 drop-shadow-sm"
                />
              ))}
            </div>
            <div className="text-left">
              <div className="flex items-baseline gap-1">
                <span className="text-4xl font-bold bg-gradient-to-r from-yellow-500 to-amber-500 bg-clip-text text-transparent">{averageRating}</span>
                <span className="text-slate-500 text-lg">/5</span>
              </div>
              <p className="text-sm text-slate-500">Basé sur {reviewCount} avis Google</p>
            </div>
            
            {/* Google badge */}
            <div className="flex items-center gap-2 pl-6 border-l border-slate-200">
              <svg className="w-8 h-8" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span className="text-slate-500 text-sm font-medium">Google Reviews</span>
            </div>
          </div>
        </div>

        {/* Testimonials Marquee — défilement infini sur 1 ligne */}
        <div
          className="relative -mx-4 sm:-mx-6 lg:-mx-8 reviews-marquee-mask"
          data-testid="testimonials-grid"
        >
          <div
            className="flex gap-5 reviews-marquee-track py-6"
            aria-label="Avis clients Google en défilement"
          >
            {[...testimonials, ...testimonials].map((testimonial, index) => (
              <a
                key={index}
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative shrink-0 w-[280px] sm:w-[340px] block"
                data-testid={`testimonial-card-${index}`}
                aria-hidden={index >= testimonials.length}
              >
                <div
                  className="review-glass-card relative rounded-2xl p-5 sm:p-6 h-[280px] sm:h-[320px] flex flex-col overflow-hidden transition-all duration-300 group-hover:-translate-y-0.5"
                  data-testid={`testimonial-card-inner-${index}`}
                >
                  {/* Inner top highlight (catch light) */}
                  <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/90 to-transparent pointer-events-none" />

                  {/* Decorative quote, subtle */}
                  <Quote
                    size={64}
                    className="absolute -top-3 -right-2 text-slate-300/30 pointer-events-none"
                    strokeWidth={1.5}
                  />

                  {/* Top row : stars + date */}
                  <div className="flex items-center justify-between mb-3 relative">
                    <div className="flex items-center gap-0.5" data-testid={`testimonial-rating-${index}`}>
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          size={14}
                          className={i < testimonial.rating ? 'fill-amber-400 text-amber-400' : 'fill-slate-200 text-slate-200'}
                          strokeWidth={0}
                        />
                      ))}
                    </div>
                    <span className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 shrink-0">
                      {testimonial.date}
                    </span>
                  </div>

                  {/* Quote text */}
                  <p
                    className="text-[14px] text-slate-700 leading-[1.55] flex-1 relative line-clamp-[8]"
                    data-testid={`testimonial-text-${index}`}
                  >
                    <span className="text-slate-900 font-semibold">«&nbsp;</span>
                    {testimonial.text}
                    <span className="text-slate-900 font-semibold">&nbsp;»</span>
                  </p>

                  {/* Footer */}
                  <div className="flex items-end justify-between pt-3 mt-3 border-t border-slate-200/60 relative">
                    <div className="min-w-0 pr-2">
                      <div className="flex items-center gap-1.5">
                        <p className="font-semibold text-slate-900 text-[13px] truncate" data-testid={`testimonial-name-${index}`}>
                          {testimonial.name}
                        </p>
                        {testimonial.verified && (
                          <BadgeCheck size={13} className="text-blue-500 shrink-0" strokeWidth={2.4} />
                        )}
                      </div>
                      <p className="text-[11px] text-slate-500 truncate mt-0.5">
                        {testimonial.device}
                      </p>
                    </div>

                    {/* Google badge bottom-right */}
                    <div className="flex items-center gap-1.5 shrink-0">
                      <svg className="w-4 h-4" viewBox="0 0 24 24">
                        <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                      </svg>
                      <span className="text-[10px] font-medium text-slate-500 uppercase tracking-wider">Avis</span>
                    </div>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a
            href={googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-slate-200 rounded-full text-slate-700 font-semibold hover:border-[#0052FF] hover:text-[#0052FF] transition-all hover-lift"
            data-testid="view-all-reviews"
          >
            Voir les {reviewCount} avis sur Google
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
